import React from "react";

import {
  OperatorAccountRequestListWidget
} from "@auto/users/__OperatorAccountRequestListWidget";

/*
 * Developer-owned composition point. Load operator_account_request_annex
 * rows here and add project-specific columns/actions.
 */
const enrichRows = async (rows) => rows;
const extraColumns = [];

export const displayOperatorAccountRequestList = (gui) => ({
  uuid: "operator-account-request-list",
  view: () => (
    <OperatorAccountRequestListWidget
      gui={gui}
      enrichRows={enrichRows}
      extraColumns={extraColumns}
    />
  )
});

export default displayOperatorAccountRequestList;
